import { MEDIA_URL } from "../../utils/config"
import i18n from "../../services/i18n"
import { permSync } from "../../utils/permSync"   // Boshliq «Menejer huquqlari» (2026-09-14)

import normalizeCurrency from "../../utils/normalizeCurrency"
import Truncate from "../../components/text/Truncate"
import placeholderImg from "../../assets/images/placeholder.png"
import { IColumnType } from "../../types"
// import ProductCountButton from "../../components/button/ProductCountButton";
import DownloadImage from "../../components/image/DownloadImage"
import {
  transfer_product,
  transfer_product_productCategory,
  trensfer_product_productUnit,
} from "./types/transform"
import { Tag, Button, InputNumber, message, Input, Tooltip, Modal as AntModal } from "antd"
import TransferHistory from "./TransferHistory"   // tog'a #2455
import { StorageHint } from "../../components/storage/Storage"   // tog'a #3520 (5-band): manba skladdagi joy
import TransferPriceCell, { narxlar } from "./TransferPriceCell"   // tog'a #2888
import { openTransferEdit } from "./TransferEditModal"   // tog'a #3177
import { SET_TRANSFER_HIDE_QTY } from "./mutations"   // tog'a #3248
import Modal from "../../components/modal/DraggableModal"   // talabnoma §8.2 (2026-09-06): siljitiladigan modal
import {
  APPROVE_TRANSFER,
  DELIVER_TRANSFER,
  CANCEL_TRANSFER,
  ACCEPT_TRANSFER_WITH_COUNT,
  REJECT_TRANSFER,
} from "./mutations"
import { purchase_purchase_user } from "../purchases/types/purchase"
import { nonNeg } from "../../utils/nonNeg"   // tog'a #1952: son 0 dan past ko'rsatilmaydi
import { isMainSystem } from "../../utils/mainSystem"   // tog'a #4104

export const columns: IColumnType[] = [
  {
    title: i18n.t("dateTransfer") || i18n.t("date"),
    dataIndex: "inserted",
    align: "center",
    sorter: true,
    render: (inserted: string) => (
      <Truncate text={new Date(inserted).toLocaleString("ru")} chars={18} />
    ),
    renderString: (inserted) => new Date(inserted).toLocaleString("ru"),
  },
  {
    // tog'a #2455: perevod hujjati raqami (TR-…); hujjatsiz eski perevod — #id
    title: i18n.t("document"),
    dataIndex: "transferNumber",
    key: "transferNumber",
    align: "center",
    // tog'a #2883 (2026-09-26): zakaz uchun avto-perevod — «для заказа ORD-…» yorlig'i (izoh «Для заказа …» dan)
    render: (v: string, r: any) => (
      <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
        {v || "#" + r?.id}
        {/^Для заказа /.test(r?.note || "") && (
          <div data-testid="tr-for-order" style={{ fontSize: 11, fontWeight: 500, color: "#3b82f6" }}>🛒 {i18n.t("pvForOrder")} {String(r.note).replace(/^Для заказа /, "")}</div>
        )}
      </span>
    ),
    renderString: (v: string, r: any) => v || "#" + r?.id,
  },
  {
    title: i18n.t("author") || i18n.t("author"),
    dataIndex: "mainUsers",
    align: "center",
    render: (mainUsers: purchase_purchase_user) => (
      <Truncate text={`${mainUsers?.userName || ""}${mainUsers?.email ? ` [${mainUsers.email}]` : ""}`} />
    ),
    renderString: (mainUsers: purchase_purchase_user) =>
      `${mainUsers?.userName || ""}${mainUsers?.email ? ` [${mainUsers.email}]` : ""}`,
  },
  {
    title: i18n.t("product") || i18n.t("product"),
    dataIndex: "mainProduct",
    align: "left",
    render: (mainProduct: any) => {
      if (!mainProduct) return <span style={{ color: "#94a3b8" }}>—</span>
      const photoUrl = mainProduct.photo ? `${MEDIA_URL}${mainProduct.photo}` : placeholderImg
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", textAlign: "left" }}>
          <img
            src={photoUrl}
            alt={mainProduct.nameModel || "Product"}
            onError={(e: any) => {
              e.target.onerror = null
              e.target.src = placeholderImg
            }}
            style={{
              width: 44,
              height: 44,
              borderRadius: 6,
              objectFit: "cover",
              border: "1px solid #e2e8f0",
              flexShrink: 0,
            }}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
            <span style={{ fontWeight: 600, color: "#1e293b", fontSize: "13px" }}>
              {mainProduct.nameModel || i18n.t("untitled")}
            </span>
            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", alignItems: "center" }}>
              {/* tog'a #2032: artikul va shtrix-kod — alohida ustunlarda (rol bo'yicha yashirish mumkin) */}
              {mainProduct.productCategory?.name && (
                <span style={{ fontSize: "11px", color: "#64748b" }}>
                  {mainProduct.productCategory.name}
                </span>
              )}
            </div>
          </div>
        </div>
      )
    },
    renderString: (mainProduct: any) => (mainProduct ? mainProduct.nameModel || "" : "—"),
  },
  // toga #2060 (2026-09-14): tartib Товар → Штрих-код → Артикул → Партия
  {
    title: i18n.t("barCode"),
    dataIndex: "mainProduct",
    key: "barCode",
    align: "center",
    render: (mainProduct: any) => (mainProduct?.barCode ? <span style={{ fontVariantNumeric: "tabular-nums" }}>{mainProduct.barCode}</span> : <span style={{ color: "#94a3b8" }}>—</span>),
    renderString: (mainProduct: any) => mainProduct?.barCode || "",
  },
  {
    // tog'a #2032 (2026-09-14): perevodda artikul, shtrix-kod, partiya — jadvalda alohida
    title: i18n.t("article"),
    dataIndex: "mainProduct",
    key: "article",
    align: "center",
    render: (mainProduct: any) => (mainProduct?.article ? <span style={{ fontWeight: 500 }}>{mainProduct.article}</span> : <span style={{ color: "#94a3b8" }}>—</span>),
    renderString: (mainProduct: any) => mainProduct?.article || "",
  },
  {
    // talabnoma §5 (2026-09-06): partiya raqami (9-bosqichgacha — manba zakupka hujjati)
    title: i18n.t("numberParty"),
    dataIndex: "batchNumber",
    align: "center",
    render: (v: string, record: any) => <Truncate text={v || record?.purchaseDocument || "—"} chars={16} />,
    renderString: (v: string, record: any) => v || record?.purchaseDocument || "",
  },
  {
    title: i18n.t("oldWarehouseName") || i18n.t("fromWarehouse"),
    dataIndex: "oldWarehouseName",
    align: "center",
    sorter: true,
    // tog'a #3520 (5-band): faol perevodda (kutilmoqda / yo'lda) — tovar MANBA skladning qaysi joyida («Зона · A-1»), skladchi qayerdan olishini bilsin
    render: (oldWarehouseName: string, record: any) => (
      <>
        <Tag color="orange" style={{ fontWeight: 500, fontSize: "12px" }}>
          {oldWarehouseName || "—"}
        </Tag>
        {(record?.status === 0 || record?.status === 1) && <StorageHint productId={Number(record?.transferProductId) || 0} warehouseId={Number(record?.oldWarehouseId) || 0} />}
      </>
    ),
    renderString: (text) => text,
  },
  {
    title: i18n.t("newWarehouseName") || i18n.t("toWarehouse"),
    dataIndex: "newWarehouseName",
    align: "center",
    sorter: true,
    render: (newWarehouseName: string) => (
      <Tag color="cyan" style={{ fontWeight: 500, fontSize: "12px" }}>
        {newWarehouseName || "—"}
      </Tag>
    ),
    renderString: (text) => text,
  },
  {
    title: i18n.t("transferCount") || i18n.t("count"),
    dataIndex: "transferCount",
    align: "center",
    sorter: true,
    render: (transferCount: any, record: any) => {
      const unitName = record?.unitName || record?.mainProduct?.productUnit?.name || i18n.t("gpPcs")
      // tog'a #3248: «скрытый приём» — qabul qiluvchi sonni qabulgacha ko'rmaydi
      if (record?.qtyHidden) return <Tag color="purple" data-testid="transfer-qty-hidden">🙈 {i18n.t("trQtyHidden", "скрыто")}</Tag>
      if (record?.blindReceive && (record?.status === 0 || record?.status === 1)) return (
        <Tooltip title={i18n.t("trBlindTip", "Скрытый приём: получатель не видит количество")}>
          <span style={{ fontWeight: 600, fontSize: "13px" }}>🙈 {transferCount} <span style={{ fontSize: "11px", color: "#64748b", fontWeight: 400 }}>{unitName}</span></span>
        </Tooltip>
      )
      return (
        <span style={{ fontWeight: 600, color: "#0f172a", fontSize: "13px" }}>
          {transferCount} <span style={{ fontSize: "11px", color: "#64748b", fontWeight: 400 }}>{unitName}</span>
        </span>
      )
    },
    renderString: (transferCount, record) => record?.qtyHidden ? i18n.t("trQtyHidden", "скрыто") : `${transferCount} ${record?.unitName || record?.mainProduct?.productUnit?.name || ""}`,
  },
  // tog'a #2888 (2026-09-26): «Цена продажи» (perevod paytidagi nusxa) va yonida aniq «Цена перевода», so'ng summa
  {
    title: i18n.t("trSalePrice"),
    key: "salePriceUSD",
    align: "right",
    render: (_: any, record: any) => {
      const v = narxlar(record).sale
      return <span style={{ color: "#64748b" }}>{v == null ? "—" : `$${normalizeCurrency(v)}`}</span>
    },
    renderString: (_: any, record: any) => { const v = narxlar(record).sale; return v == null ? "" : String(v) },
  },
  {
    title: i18n.t("trTransferPrice"),
    key: "transferPriceUSD",
    align: "right",
    render: (_: any, record: any) => <TransferPriceCell record={record} />,
    renderString: (_: any, record: any) => { const v = narxlar(record).transfer; return v == null ? "" : String(v) },
  },
  {
    title: i18n.t("trSum"),
    key: "transferSumUSD",
    align: "right",
    render: (_: any, record: any) => {
      const v = narxlar(record).transfer
      if (record?.qtyHidden) return "—"   // tog'a #3248
      return v == null ? "—" : <b>${normalizeCurrency(Math.round(v * (Number(record?.transferCount) || 0) * 100) / 100)}</b>
    },
    renderString: (_: any, record: any) => { const v = narxlar(record).transfer; return v == null ? "" : String(Math.round(v * (Number(record?.transferCount) || 0) * 100) / 100) },
  },
  {
    title: i18n.t("status"),
    dataIndex: "status",
    align: "center",
    // tog'a #2455 (2026-09-24): tugmalar faqat ruxsat bo'lganda — server har qatorga canAccept/canSend/canCancel beradi
    // (qabul/rad — qabul qiluvchi sklad, «Отправить» — jo'natuvchi). Avval hamma tugma hammaga chizilib, server 403 qaytarardi.
    render: (status: number, record: any) => {
      const ruxsat = permSync("transfers")
      const mayAccept = ruxsat.canEdit && (record?.canAccept ?? true)
      const maySend = ruxsat.canEdit && (record?.canSend ?? true)
      const mayCancel = ruxsat.canDelete && (record?.canCancel ?? true)
      const mayEdit = ruxsat.canEdit && record?.canEdit === true && Number(record?.transferDocId) > 0   // tog'a #3177: faqat «Ожидание»
      const vaqt = (d?: string) => (d ? new Date(d).toLocaleString("ru", { dateStyle: "short", timeStyle: "short" }) : "")
      const btn = { fontSize: "11px", height: "24px" }
      const ustun: React.CSSProperties = { display: "flex", flexDirection: "column", alignItems: "center", gap: "3px" }
      const kichik: React.CSSProperties = { fontSize: "10px", color: "#94a3b8" }
      // tog'a #3248: jo'natuvchi sklad qabulgacha «скрытый приём»ni yoqadi / o'chiradi
      const yashirTugma = ruxsat.canEdit && record?.canEditPrice && !record?.qtyHidden && Number(record?.transferDocId) > 0 && (status === 0 || status === 1) ? (
        <Tooltip title={record?.blindReceive ? i18n.t("trBlindOff", "Показать количество получателю") : i18n.t("trBlindOn", "Скрыть количество от получателя")}>
          <Button type="link" size="small" style={{ fontSize: 11, height: 20, padding: 0 }} data-testid="transfer-hide-toggle"
            onClick={async (e) => {
              e.stopPropagation()
              try { await SET_TRANSFER_HIDE_QTY(Number(record.transferDocId), !record?.blindReceive); window.location.reload() }
              catch (err: any) { message.error(err?.response?.data?.message || String(err)) }
            }}>
            {record?.blindReceive ? "👁 " + i18n.t("trBlindShow", "Показать кол-во") : "🙈 " + i18n.t("trBlindHide", "Скрыть кол-во")}
          </Button>
        </Tooltip>
      ) : null
      const tarix = (
        <span style={{ display: "inline-flex", gap: 8 }}>
        <Button type="link" size="small" style={{ fontSize: 11, height: 20, padding: 0 }} data-testid="transfer-history-open"
          onClick={(e) => { e.stopPropagation(); openHistory(record) }}>
          🕘 {i18n.t("transferHistory", "История")}
        </Button>
        {yashirTugma}
        </span>
      )
      const qabulTugmalari = mayAccept ? (
        <>
          <Button size="small" type="primary" style={{ ...btn, backgroundColor: "#16a34a", borderColor: "#16a34a" }}
            hidden={!!record?.qtyHidden}   // tog'a #3248: skrytiy priyomda faqat «По факту»
            onClick={async (e) => { e.stopPropagation(); try { await DELIVER_TRANSFER(record.id); window.location.reload() } catch (err: any) {} }}>
            Принять
          </Button>
          <Button size="small" style={btn} type={record?.qtyHidden ? "primary" : "default"} data-testid="transfer-accept-fact" onClick={(e) => { e.stopPropagation(); openAcceptModal(record) }}>По факту</Button>
          <Button size="small" danger style={btn} data-testid="transfer-reject" onClick={(e) => { e.stopPropagation(); openReasonModal("reject", record) }}>
            {i18n.t("trReject", "Отклонить")}
          </Button>
        </>
      ) : null
      const bekor = mayCancel ? (
        <Tooltip title={i18n.t("cancelTransferQ")}>
          <Button size="small" danger style={btn} data-testid="transfer-cancel" onClick={(e) => { e.stopPropagation(); openReasonModal("cancel", record) }}>✕</Button>
        </Tooltip>
      ) : null
      if (status === 3) {
        const rad = record?.closedKind === "rejected"
        return (
          <div style={ustun}>
            <Tooltip title={record?.closedReason ? `${i18n.t("reason")}: ${record.closedReason}` : undefined}>
              <Tag color={rad ? "volcano" : "red"} style={{ fontWeight: 600, padding: "2px 8px" }}>
                {rad ? "⛔ " + i18n.t("trRejected", "Отклонён получателем") : "✕ Отменён"}
              </Tag>
            </Tooltip>
            {(record?.closedByName || record?.cancelledAt) && (
              <span style={kichik}>{[record?.closedByName, vaqt(record?.cancelledAt)].filter(Boolean).join(" · ")}</span>
            )}
            {record?.closedReason && <span style={{ fontSize: 10, color: "#b45309", maxWidth: 220 }}>{record.closedReason}</span>}
            {tarix}
          </div>
        )
      }
      if (status === 2) {
        const shortage =
          record.acceptedCount != null && record.acceptedCount < record.transferCount
            ? record.transferCount - record.acceptedCount
            : 0
        return (
          <div style={ustun}>
            <Tag color="blue" style={{ fontWeight: 600, padding: "2px 8px" }}>
              ✅ Принят (TRANSFER_COMPLETED)
            </Tag>
            {shortage > 0 && (
              <Tag color="volcano" style={{ fontSize: "10px", margin: 0 }}>
                Недостача: {shortage}
              </Tag>
            )}
            <span style={kichik}>
              {[record?.acceptedByName ? i18n.t("trAcceptedBy", "Принял") + ": " + record.acceptedByName : null, vaqt(record?.acceptedAtJ || record?.deliveredAt)].filter(Boolean).join(" · ")}
            </span>
            {tarix}
          </div>
        )
      }
      if (status === 1) {
        return (
          <div style={ustun}>
            <Tag color="green" style={{ fontWeight: 600 }}>
              🚚 В пути — ждёт приёма склада-получателя
            </Tag>
            {(qabulTugmalari || bekor) && <div style={{ display: "flex", gap: 4, flexWrap: "wrap", justifyContent: "center" }}>{qabulTugmalari}{bekor}</div>}
            {tarix}
          </div>
        )
      }
      return (
        <div style={ustun}>
          <Tag color="orange" style={{ fontWeight: 600 }}>
            ⏳ Ожидание (TRANSFER_PENDING) — резерв на складе-отправителе
          </Tag>
          {/* talabnoma §5 (2026-09-06): «Отправить» = jo'natuvchi (B'ga kirim YO'Q), «Принять» = qabul qiluvchi sklad (kirim shu yerda).
              tog'a #3018 (2026-09-29): yuborilmagan perevodda qabul tugmalari (Принять / По факту / Отклонить) chizilmaydi — server
              «Принять» ni «Отправить» dan oldin baribir 409 bilan rad etadi (#2883 S1); bu holatda faqat «Отправить» va bekor qilish. */}
          {(maySend || bekor || mayEdit) && (
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap", justifyContent: "center" }}>
              {/* tog'a #3177 (2026-10-02): «Ожидание»dagi perevodni o'zgartirish — son, qator, qabul ombori */}
              {mayEdit && (
                <Button size="small" style={btn} data-testid="transfer-edit" onClick={(e) => { e.stopPropagation(); openTransferEdit(record) }}>✏️ {i18n.t("edit", "Изменить")}</Button>
              )}
              {maySend && (
                <Button size="small" style={btn}
                  onClick={async (e) => { e.stopPropagation(); try { await APPROVE_TRANSFER(record.id); window.location.reload() } catch (err: any) {} }}>
                  Отправить
                </Button>
              )}
              {bekor}
            </div>
          )}
          {tarix}
        </div>
      )
    },
    renderString: (status: number) =>
      status === 3 ? i18n.t("cancelled") : status === 2 ? i18n.t("deliveredStatusM") : status === 1 ? i18n.t("inTransitStatus") : i18n.t("awaitingStatus"),
  },
]

// tog'a #2455 (2026-09-24): rad etish (qabul qiluvchi) va bekor qilish — sabab MAJBURIY, jurnalga yoziladi,
// ikkinchi tomon bildirishnoma oladi. Sabab 3 belgidan kam bo'lsa oyna yopilmaydi.
function openReasonModal(kind: "reject" | "cancel", record: any) {
  let sabab = ""
  AntModal.confirm({
    title: kind === "reject" ? i18n.t("trRejectTitle", "Отклонить перемещение") : i18n.t("cancelTransferQ"),
    content: (
      <div>
        <div style={{ marginBottom: 8, fontSize: 12, opacity: 0.85 }}>
          <b>{record?.mainProduct?.nameModel || "—"}</b> · {record?.qtyHidden ? "🙈 " + i18n.t("trQtyHidden", "скрыто") : record?.transferCount} · {record?.oldWarehouseName || "—"} → {record?.newWarehouseName || "—"}
        </div>
        <Input.TextArea
          rows={3}
          maxLength={500}
          data-testid="transfer-reason"
          placeholder={kind === "reject" ? i18n.t("trRejectReason", "Причина отказа (обязательно)") : i18n.t("trCancelReason", "Причина отмены (обязательно)")}
          onChange={(e) => { sabab = e.target.value }}
        />
        <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>
          {kind === "reject"
            ? i18n.t("trRejectHint", "Товар вернётся на склад-отправитель, отправитель получит уведомление.")
            : i18n.t("trCancelHint", "Товар вернётся на склад-отправитель, склад-получатель получит уведомление.")}
        </div>
      </div>
    ),
    okText: kind === "reject" ? i18n.t("trReject", "Отклонить") : i18n.t("yes"),
    okButtonProps: { danger: true },
    cancelText: i18n.t("no"),
    onOk: async () => {
      const t = sabab.trim()
      if (t.length < 3) {
        message.error(i18n.t("trReasonMin", "Укажите причину (минимум 3 символа)"))
        throw new Error("reason")
      }
      await (kind === "reject" ? REJECT_TRANSFER(record.id, t) : CANCEL_TRANSFER(record.id, t))
      message.success(kind === "reject" ? i18n.t("trRejectedDone", "Перемещение отклонено") : i18n.t("transferCancelled"))
      window.location.reload()
    },
  })
}

// tog'a #2455: perevod tarixi oynasi
function openHistory(record: any) {
  AntModal.info({
    title: i18n.t("transferHistoryTitle", "История перемещения"),
    width: 900,
    icon: null,
    maskClosable: true,
    okText: i18n.t("close"),
    content: <TransferHistory id={record.id} />,
  })
}

// 2-bosqich TZ: tafovut bilan qabul — fakt miqdorni so'rab AcceptWithCount chaqiradi.
// Kamomad bo'lsa backend avtomatik dalolatnoma yozuvini shakllantiradi.
function openAcceptModal(record: any) {
  const yopiq = !!record?.qtyHidden   // tog'a #3248: «скрытый приём»
  let actualCount: number = yopiq ? 0 : record?.transferCount || 0
  Modal.confirm({
    title: i18n.t("acceptActual"),
    content: (
      <div>
        {/* tog'a #2032: qaysi tovar qabul qilinayotgani aniq ko'rinsin */}
        <div style={{ marginBottom: 10, padding: "8px 10px", border: "1px solid rgba(148,163,184,0.35)", borderRadius: 8, lineHeight: 1.5 }}>
          <div style={{ fontWeight: 600 }}>{record?.mainProduct?.nameModel || "—"}</div>
          <div style={{ fontSize: 12, opacity: 0.8 }}>
            {i18n.t("article")}: {record?.mainProduct?.article || "—"} · {i18n.t("barCode")}: {record?.mainProduct?.barCode || "—"}
            {/* tog'a #4104: partiya faqat glavniy tizimda */}
            {isMainSystem() ? ` · ${i18n.t("numberParty")}: ${record?.batchNumber || record?.purchaseDocument || "—"}` : null}
          </div>
          <div style={{ fontSize: 12, opacity: 0.8 }}>{record?.oldWarehouseName || "—"} → {record?.newWarehouseName || "—"}</div>
        </div>
        {yopiq ? (
          <div style={{ marginBottom: 8 }} data-testid="transfer-blind-hint">
            🙈 <b>{i18n.t("trBlindAcceptTitle", "Скрытый приём")}</b>: {i18n.t("trBlindAcceptHint", "пересчитайте товар и укажите, сколько фактически пришло. Отправленное количество не показывается; при недостаче акт сформируется автоматически.")}
          </div>
        ) : (
        <div style={{ marginBottom: 8 }}>
          Отправлено: <b>{record?.transferCount}</b>. Укажите фактически принятое количество
          (при недостаче автоматически формируется акт):
        </div>
        )}
        <InputNumber
          data-testid="transfer-accept-count"
          min={0.01}
          max={yopiq ? undefined : record?.transferCount}
          step={1}
          defaultValue={yopiq ? undefined : record?.transferCount}
          onChange={(v) => {
            actualCount = Number(v) || 0
          }}
          style={{ width: "100%" }}
        />
      </div>
    ),
    okText: i18n.t("accept"),
    cancelText: i18n.t("cancel"),
    onOk: async () => {
      if (!(actualCount > 0)) { message.error(i18n.t("trEnterCount", "Укажите количество")); throw new Error("count") }
      await ACCEPT_TRANSFER_WITH_COUNT(record.id, actualCount)
      message.success(i18n.t("accepted"))
      window.location.reload()
    },
  })
}

// Kunlar bo'yicha guruhlangan ko'rinish uchun ustunlar (har bir qator — bitta kun)
export const groupColumns: IColumnType[] = [
  {
    title: i18n.t("dateTransfer") || i18n.t("date"),
    dataIndex: "date",
    align: "center",
    sorter: true,
    render: (date: string) => new Date(date).toLocaleDateString("ru"),
    renderString: (date: string) => new Date(date).toLocaleDateString("ru"),
  },
  {
    title: i18n.t("transferMovesCount"),
    dataIndex: "transfersCount",
    align: "center",
    sorter: true,
    render: (transfersCount: number) => (
      <span style={{ fontWeight: 600 }}>{transfersCount}</span>
    ),
    renderString: (text) => text,
  },
  {
    title: i18n.t("totalQtyPcs"),
    dataIndex: "totalAmount",
    align: "center",
    sorter: true,
    render: (totalAmount: number) => normalizeCurrency(totalAmount || 0),
    renderString: (text) => text,
  },
  {
    title: i18n.t("statuses"),
    dataIndex: "pendingCount",
    align: "center",
    render: (_: any, record: any) => (
      <div style={{ display: "flex", gap: 4, justifyContent: "center", flexWrap: "wrap" }}>
        {record.pendingCount > 0 && <Tag color="orange">⏳ {record.pendingCount}</Tag>}
        {record.approvedCount > 0 && <Tag color="green">✓ {record.approvedCount}</Tag>}
        {record.deliveredCount > 0 && <Tag color="blue">🚚 {record.deliveredCount}</Tag>}
      </div>
    ),
    renderString: (_: any, record: any) =>
      `В ожидании: ${record?.pendingCount || 0}, В пути: ${record?.approvedCount || 0}, Доставлен: ${record?.deliveredCount || 0}`,
  },
]

// Boshliq (2026-09-03, 6-qaror): «Kam chiqdi» ro'yxati ustunlari.
// Maqsad — kim jo'natgan, kim qabul qilgan, qancha farq, qachon: hammasi ko'rinsin.
export const shortageColumns: IColumnType[] = [
  {
    title: i18n.t("date"),
    dataIndex: "date",
    align: "center",
    render: (v: string) => <Truncate text={new Date(v).toLocaleString("ru")} chars={18} />,
    renderString: (text) => text,
  },
  {
    title: i18n.t("product"),
    dataIndex: "productName",
    align: "center",
    render: (v: string) => <Truncate text={v || "—"} chars={22} />,
    renderString: (text) => text,
  },
  {
    title: i18n.t("barCode"),   // tog'a #2032
    dataIndex: "barCode",
    align: "center",
    render: (v: string) => v || "—",
    renderString: (text) => text,
  },
  {
    title: i18n.t("article"),
    dataIndex: "article",
    align: "center",
    render: (v: string) => v || "—",
    renderString: (text) => text,
  },
  {
    title: i18n.t("numberParty"),   // tog'a #2032
    dataIndex: "batchNumber",
    align: "center",
    render: (v: string) => v || "—",
    renderString: (text) => text,
  },
  {
    title: i18n.t("fromWarehouse") || i18n.t("warehouse"),
    dataIndex: "fromWarehouse",
    align: "center",
    render: (v: string) => <Truncate text={v || "—"} chars={16} />,
    renderString: (text) => text,
  },
  {
    title: i18n.t("toWarehouse") || i18n.t("warehouse"),
    dataIndex: "toWarehouse",
    align: "center",
    render: (v: string) => <Truncate text={v || "—"} chars={16} />,
    renderString: (text) => text,
  },
  {
    title: i18n.t("sentQty"),
    dataIndex: "sent",
    align: "center",
    render: (v: number) => normalizeCurrency(v),
    renderString: (text) => text,
  },
  {
    title: i18n.t("acceptedQty"),
    dataIndex: "accepted",
    align: "center",
    render: (v: number) => normalizeCurrency(v),
    renderString: (text) => text,
  },
  {
    title: i18n.t("shortageQty"),
    dataIndex: "shortage",
    align: "center",
    // Farq — asosiy ustun, shuning uchun ajratib ko'rsatiladi
    render: (v: number) => (
      <Tag color="red" style={{ fontWeight: 600, fontSize: 13 }}>{normalizeCurrency(nonNeg(v))}</Tag>
    ),
    renderString: (text) => text,
  },
  {
    title: i18n.t("sentBy"),
    dataIndex: "sentBy",
    align: "center",
    render: (v: string) => <Truncate text={v || "—"} chars={16} />,
    renderString: (text) => text,
  },
  {
    title: i18n.t("acceptedBy"),
    dataIndex: "acceptedBy",
    align: "center",
    render: (v: string) => <Truncate text={v || "—"} chars={16} />,
    renderString: (text) => text,
  },
]
